/**
 * 저작 job 의 **실제 경과시간**.
 *
 * UI-D5(a) 가 진행 표시의 재료로 삼는 유일한 수다. 가짜 %가 사라진 자리를 이것이 채운다 —
 * 추정이 아니라 관측이라, 틀릴 수가 없다는 점이 중요하다(P1).
 *
 * 규율: **진행 중일 때만 흐르고, 끝나면 그 시점에서 동결한다**(DESIGN §5). 종료된 job 의
 * 타이머가 계속 올라가면 "아직 도는 중"으로 읽힌다.
 */
import { isActive } from './types'
import type { JobView } from './types'

function parse(iso: string | null): number | null {
  if (!iso) return null
  const ms = new Date(iso).getTime()
  return Number.isNaN(ms) ? null : ms
}

/** 초 단위 경과. 계산할 근거가 없으면 `null` — 0초라고 지어내지 않는다. */
export function elapsedSeconds(job: JobView, nowMs: number): number | null {
  const started = parse(job.created_at)
  if (started === null) return null
  const end = isActive(job) ? nowMs : (parse(job.finished_at) ?? nowMs)
  return Math.max(0, Math.floor((end - started) / 1000))
}

/** `{ m, s }` — 문구 조립은 i18n 이 한다(언어마다 어순이 다르다). */
export function splitElapsed(seconds: number): { m: number; s: string } {
  return { m: Math.floor(seconds / 60), s: String(seconds % 60).padStart(2, '0') }
}
